interface SignInResult {
    isSignedIn: boolean;
    nextStep?: {
        signInStep: string;
    };
}

export function assertSignInCompleted(result: SignInResult): void {
    if (result.isSignedIn) return;
    throw new Error(`Sign-in did not complete. Next step: ${result.nextStep?.signInStep || 'unknown'}`);
}
